const initialState = {};

export default (state=initialState, action) => {
	switch (action.type) {
    case 'UPDATE_NAME':
      return {...state, ...action.payload};
    case 'UPDATE_BIRTHDATE':
      return {...state, birthdate: action.date}
    case 'UPDATE_CONTACT':
      return {...state, ...action.payload}
    case 'UPDATE_ADDRESS':
      return {...state, address: {...action.payload}}
    case 'UPDATE_MAILING_ADDRESS':
      return {...state, mailingAddress: {...action.payload}}
    case 'UPDATE_LIVING_SITUATION':
      return {...state, ...action.payload}   
		default: 
			return state			
	}
}


// WEBPACK FOOTER //
// ./src/reducers/personalInfoReducer.js